import { useEffect, useState } from 'react';

export const useDetectKeyboard = () => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [keyboardHeight, setKeyboardHeight] = useState(0);

    useEffect(() => {
        // Проверка поддержки API
        if (!window.visualViewport) {
            console.warn('VisualViewport API is not supported in this browser');
            return;
        }

        const handleResize = () => {
            const visualViewportHeight = window.visualViewport?.height || 0;
            const windowHeight = window.innerHeight;

            const pixelRatio = window.devicePixelRatio || 1;
            const diff = (windowHeight - visualViewportHeight) * pixelRatio;
            const isOpen = diff > 110;

            setIsKeyboardOpen(isOpen);
            setKeyboardHeight(isOpen ? diff : 0);
        };

        window.visualViewport.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.visualViewport?.removeEventListener('resize', handleResize);
        };
    }, []);

    return { isKeyboardOpen, setIsKeyboardOpen, keyboardHeight };
};
